export default "__VITE_ASSET__DqTPklsa__"